import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDAlert } from '@facet-wealth/design';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <PXTextModalWrapper primaryButtonLabel={"Let's do this →"}>
      <MetaControlField attr={'description'} />
      {resource.attr('infoTitle') && <FDAlert status={'info'} title={resource.attr('infoTitle')} description={resource.attr('infoText')} />}
      <MetaControlField attr={'callToAction'} />
    </PXTextModalWrapper>
  );
};

export default Layout;
